import { shouldApplyEAEULogic } from './eaeuHelper';

export const CARGO_NAME_MESSAGE = 'СДЭК просит уточнить название товара. Укажите, что именно отправляете.';
export const COUNTRY_CHECK_MESSAGE = 'Не удалось проверить страны маршрута. Проверьте выбранные города и повторите попытку.';
const GENERIC_NAMES = new Set(['груз', 'личные вещи', 'тнп', 'товар', 'посылка', 'вещи', 'коробка', 'personal items', 'жеке заттар']);
const COUNTRY_CODES = {RU: 1, BY: 42, KZ: 48, KG: 15, AM: 41};

/** @param {number|string|null|undefined} value */
export function normalizeCargoCountryCode(value) {
    if (typeof value === 'string' && /^[A-Z]{2}$/.test(value)) {
        return COUNTRY_CODES[value] ?? value;
    }
    if (typeof value !== 'number' && typeof value !== 'string') return null;
    const code = Number(value);
    return Number.isInteger(code) && code > 0 ? code : null;
}

export function isUnsuitableCargoName(value) {
    const name = String(value ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
    return !name || /^\p{Nd}+$/u.test(name) || GENERIC_NAMES.has(name);
}

export function hasInvalidCargoNames(data) {
    return shouldApplyEAEULogic(normalizeCargoCountryCode(data.cityFromCountryCode), normalizeCargoCountryCode(data.cityToCountryCode)) &&
        (!data.places?.length || data.places.some(place => !place.goods?.length ||
            place.goods.some(good => isUnsuitableCargoName(good.name))));
}

/** @returns {string|null} */
export function getCargoNameValidationMessage(data) {
    if (data.cityFrom && data.cityTo &&
        (normalizeCargoCountryCode(data.cityFromCountryCode) === null ||
         normalizeCargoCountryCode(data.cityToCountryCode) === null)) {
        return COUNTRY_CHECK_MESSAGE;
    }
    return hasInvalidCargoNames(data) ? CARGO_NAME_MESSAGE : null;
}
